import { render, staticRenderFns } from "./coldChainList.vue?vue&type=template&id=72a22637"
import script from "./coldChainList.vue?vue&type=script&lang=js"
export * from "./coldChainList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports